import styled from "@emotion/styled";
import { Col, Input, Modal, Row } from "antd";
import "antd/dist/antd.css";
import React, { useState } from "react";
import { ModalLayout } from "../LayoutModals";
import { BlueButton } from "./BlueButton";
// Modal for changing the OneFid ID, assume email is meant with it

const handleSubmit = (e: Event) => {
  e.preventDefault();
};

const PopupButton = (): JSX.Element => {
  const [isVisible, setIsVisible] = useState(false);

  const showModal = () => {
    setIsVisible(true);
  };

  const handleOk = () => {
    setIsVisible(false);
  };

  const handleCancel = () => {
    setIsVisible(false);
  };

  return (
    <div>
      <BlueButton type="primary" onClick={showModal}>
        Bearbeiten
      </BlueButton>
      <Modal visible={isVisible} onOk={handleOk} onCancel={handleCancel}>
        <Row>
          <Col>
            <p style={{ fontSize: "16px" }}>
              <strong>One Fitting ID ändern</strong>
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <p style={{ marginBottom: "5px" }}>
              <strong>One Fitting ID</strong>
            </p>
            <Input
              className="EmailBar"
              placeholder="Neue One Fitting ID"
              name="android:fitsSystemWindows"
            />
            <p style={{ marginTop: "15px", marginBottom: "5px" }}>
              <strong>Passwort</strong>
            </p>
            <Input type="Password" placeholder="Passwort" />
          </Col>
          <ModalLayout handleSubmit={handleSubmit} />
        </Row>
      </Modal>
    </div>
  );
};

export const ModalButtonOneFid = styled(({ children, ...props }) => (
  <PopupButton {...props}>{children}</PopupButton>
))({});
